import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import ActivityIndicator from 'client/modules/App/components/ActivityIndicator/ActivityIndicator';
import { getCurrentOrgId } from 'client/modules/Auth/AuthReducer';
import { useListAccessLogQuery } from 'client/modules/Settings/mcpOAuthSlice';
import moment from 'moment';
import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

const messages = defineMessages({
  title: {
    id: 'McpAccessLogList.title',
    defaultMessage: 'MCP activity log',
  },
  empty: {
    id: 'McpAccessLogList.empty',
    defaultMessage: 'No MCP tool or resource access recorded yet.',
  },
  when: {
    id: 'McpAccessLogList.when',
    defaultMessage: 'When',
  },
  client: {
    id: 'McpAccessLogList.client',
    defaultMessage: 'Client',
  },
  action: {
    id: 'McpAccessLogList.action',
    defaultMessage: 'Action',
  },
  status: {
    id: 'McpAccessLogList.status',
    defaultMessage: 'Status',
  },
  success: {
    id: 'McpAccessLogList.success',
    defaultMessage: 'Success',
  },
  failed: {
    id: 'McpAccessLogList.failed',
    defaultMessage: 'Failed',
  },
});

function McpAccessLogList() {
  const { formatMessage } = useIntl();
  const orgId = useSelector(getCurrentOrgId);
  const { data, isLoading } = useListAccessLogQuery({ orgId, perPage: 25 });

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="subtitle1" component="h3" sx={{ mb: 1 }}>
        {formatMessage(messages.title)}
      </Typography>
      {isLoading && <ActivityIndicator inline />}
      {!isLoading && (!data?.items || data.items.length === 0) && (
        <Typography variant="body2" color="text.secondary">
          {formatMessage(messages.empty)}
        </Typography>
      )}
      {data?.items?.length > 0 && (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>{formatMessage(messages.when)}</TableCell>
              <TableCell>{formatMessage(messages.client)}</TableCell>
              <TableCell>{formatMessage(messages.action)}</TableCell>
              <TableCell>{formatMessage(messages.status)}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.items.map(entry => (
              <TableRow key={entry.id}>
                <TableCell>{moment(entry.createdAt).format('LLL')}</TableCell>
                <TableCell>{entry.clientName}</TableCell>
                <TableCell>
                  {entry.actionType === 'resource' ? `resource:${entry.actionName}` : entry.actionName}
                </TableCell>
                <TableCell>
                  <Chip
                    size="small"
                    label={
                      entry.success
                        ? formatMessage(messages.success)
                        : formatMessage(messages.failed)
                    }
                    color={entry.success ? 'success' : 'error'}
                    variant="outlined"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
}

export default McpAccessLogList;
